<template>
  <div>
    <ul class="status">
      <li v-for="(item, key) in languages" :key="key">
        <div>
          <input
            @change="change"
            :id="`lang-${name}-${key}`"
            :value="key"
            :name="`lang-${name}`"
            :checked="value == key"
            type="radio"
          />
          <label :for="`lang-${name}-${key}`">
            {{ item }}
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

import { mapState } from "vuex";

export default {
  props: ["value", "name"],
  methods: {
    change(e) {
      this.$emit("input", e.target.value);
    },
  },
  computed: {
    ...mapState(["languages"]),
  },
};
</script>

